import { Injectable } from "@angular/core";
import { AngularFireDatabase, AngularFireAction } from "@angular/fire/database";
import { AngularFireAuth } from "@angular/fire/auth";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class DataService {
  private companyId = "-Lus6LnKCg2j63Wypzjj";
  private allMembersGroupId = "-LyVgz2iFr0hsvx9ZjSQ";
  private foundationMissionId = "-Lzcq4CoCv4JPxaxXq70";

  constructor(
    private afAuth: AngularFireAuth,
    private afdb: AngularFireDatabase,
    private http: HttpClient
  ) {}

  getCompanyId() {
    return this.companyId;
  }

  getAllMembersGroupId() {
    return this.allMembersGroupId;
  }

  getFoundationMissionId() {
    return this.foundationMissionId;
  }

  // Get all users
  getUsers() {
    return this.afdb.list("/accounts", (ref) => ref.orderByChild("name"));
  }

  // Get all coaches
  getCoaches() {
    return this.afdb.list("/accounts", (ref) => ref.orderByChild("name"));
  }

  getCoaches2() {
    return this.afdb.list("/accounts", (ref) =>
      ref.orderByChild("isCoach").equalTo(true)
    );
  }

  // Get user with username
  getUserWithUsername(username) {
    return this.afdb.list("/accounts", (ref) =>
      ref.orderByChild("username").equalTo(username)
    );
  }

  // Get logged in user data
  getCurrentUser() {
    return this.afdb.object("/accounts/" + this.afAuth.auth.currentUser.uid);
  }

  // Get user by their userId
  getUser(userId) {
    return this.afdb.object("/accounts/" + userId);
  }

  // Get requests given the userId.
  getRequests(userId) {
    return this.afdb.object(
      "/companies/" + this.companyId + "/requests/" + userId
    );
  }

  // Get friend requests given the userId.
  getFriendRequests(userId) {
    return this.afdb.list("/companies/" + this.companyId + "/requests", (ref) =>
      ref.orderByChild("receiver").equalTo(userId)
    );
  }

  // Get conversation given the conversationId.
  getConversation(conversationId) {
    return this.afdb.object(
      "/companies/" + this.companyId + "/conversations/" + conversationId
    );
  }

  // Get conversations of the current logged in user.
  getConversations() {
    return this.afdb.list(
      "/accounts/" + this.afAuth.auth.currentUser.uid + "/conversations"
    );
  }

  // Get messages of the conversation given the Id.
  getConversationMessages(conversationId) {
    return this.afdb.object(
      "/companies/" +
        this.companyId +
        "/conversations/" +
        conversationId +
        "/messages"
    );
  }

  getGroupList(){
    return this.afdb.list(
      "/companies/" + this.companyId + "/groups"
    );
  }

  // Get messages of the group given the Id.
  getGroupMessages(groupId) {
    return this.afdb.object(
      "/companies/" + this.companyId + "/groups/" + groupId + "/messages"
    );
  }

  // Get groups of the logged in user.
  getGroups() {
    return this.afdb.list(
      "/accounts/" + this.afAuth.auth.currentUser.uid + "/groups"
    );
  }

  // Get group info given the groupId.
  getGroup(groupId) {
    return this.afdb.object(
      "/companies/" + this.companyId + "/groups/" + groupId
    );
  }

  // Get messages of the mission given the Id.
  getMissionMessages(missionId) {
    return this.afdb.object(
      "/companies/" + this.companyId + "/missions/" + missionId + "/messages"
    );
  }

  // Get missions of the logged in user.
  getMissions() {
    return this.afdb.list(
      "/accounts/" + this.afAuth.auth.currentUser.uid + "/missions"
    );
  }

  getMissionsByUserId(userId) {
    return this.afdb.list("/accounts/" + userId + "/missions");
  }

  // Get missions of the logged in user.
  getArticles() {
    return this.afdb.list("/companies/" + this.companyId + "/articles");
  }

  // Get missions of the logged in user.
  getLearning() {
    return this.afdb.list("/companies/" + this.companyId + "/learning");
  }

  // Get mission info given the missionId.
  getMission(missionId) {
    return this.afdb.object(
      "/companies/" + this.companyId + "/missions/" + missionId
    );
  }

  // Get completedMissionActions info given the userId.
  getCompletedMissionActionsByUser() {
    return this.afdb.list(
      "/companies/" + this.companyId + "/completedMissionActions",
      (ref) => ref.orderByChild("uid").equalTo(this.afAuth.auth.currentUser.uid)
    );
  }

  getCompletedMissionActionsByUserByUserId(userId) {
    return this.afdb.list(
      "/companies/" + this.companyId + "/completedMissionActions",
      (ref) => ref.orderByChild("uid").equalTo(userId)
    );
  }

  getCompletedMissionActions() {
    return this.afdb.list(
      "/companies/" + this.companyId + "/completedMissionActions",
      (ref) => ref.orderByChild("approved").equalTo(false)
    );
  }

  getBlockedLists() {
    return this.afdb.list(
      "/accounts/" + this.afAuth.auth.currentUser.uid + "/conversations",
      (ref) => ref.orderByChild("blocked").equalTo(true)
    );
  }

  getMissionList() {
    const hardwareTests = "assets/data/missions.json";
    return this.http.get(hardwareTests);
  }

  getWorkoutList() {
    // const hardwareTests = "assets/data/workouts.json";
    // return this.http.get(hardwareTests);
    return this.afdb.list("/companies/" + this.companyId + "/workouts");
  }

  // Get messages of the mission given the Id.
  getWorkout(workoutId) {
    return this.afdb.object(
      "/companies/" + this.companyId + "/workouts/" + workoutId
    );
  }

  getWorkoutAction(actionId, workoutId) {
    return this.afdb.object(
      "/companies/" +
        this.companyId +
        "/workouts/" +
        workoutId +
        "/actions/" +
        actionId
    );
  }

  getEssentialList() {
    const hardwareTests = "assets/data/essentials.json";
    return this.http.get(hardwareTests);
  }

  // Get completedMissionActions info given the userId.
  getUsersByCompanyId(companyId) {
    return this.afdb.list("/accounts", (ref) =>
      ref.orderByChild("company").equalTo(companyId)
    );
  }

  updateUser(user) {
    return this.afdb.object("/accounts/" + user.userId).update(user);
  }
}
